module.exports = __webpack_public_path__ + "static/media/Lens-Latte_TW.3a6de255.png";